import { render } from "./App.vue?vue&type=template&id=2778d6d3"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2778d6d3&lang=scss"

import exportComponent from "D:\\Softsion\\Vue\\web-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__